module.exports = __webpack_public_path__ + "img/Img24_210656_CeEt-30-47B42-1.c8d3ae1f.jpg";